import { Dispatch } from 'redux';

import firebase from '../../config/firebase';

export const startLoad = () => (dispatch: Dispatch): void => {
	dispatch({ type: 'START_LOADING' });
};

export const authenticate = () => (dispatch: Dispatch): void => {
	firebase.auth().onAuthStateChanged((user: any) => {
		if (user) {
			user.getIdTokenResult(true).then((idTokenResult: any) => {
				const mergedUser = { ...user, ...idTokenResult.claims };
				dispatch({ type: 'FINISH_LOADING' });

				dispatch({
					type: 'AUTHENTICATED',
					payload: mergedUser
				});
			});
		} else {
			dispatch({ type: 'FINISH_LOADING' });
		}
	});
};

export const logout = () => (dispatch: any) => {
	firebase
		.auth()
		.signOut()
		.then(function() {
			dispatch({ type: 'LOGOUT' });
		});
};
